/* eslint-disable @typescript-eslint/no-unused-vars */
import { yupResolver } from "@hookform/resolvers/yup"
import { Button, PasswordInput, Select, TextInput, Text } from "@mantine/core"
import { useContext, useState } from "react"
import { Controller, useForm } from "react-hook-form"
import { useSelector } from "react-redux"
import { Link, NavLink } from "react-router-dom"
import * as yup from "yup"
import { RootState } from "../../../../store/app.store"
import AuthContext from "../../context/authContext"
import CityIcon from "../../../icons/city-icon"
import { useTranslation } from "react-i18next"
import { flexiblePhoneRegEx } from "../../../utility/Tools/RegEx"
import { parsePhoneNumber } from "../../../utility/Tools/tools"
interface Account {
  phoneNumber: string
  password: string
  type?: string
}
function Login() {
  const { login } = useContext(AuthContext)
  const { t } = useTranslation()
  const [userType, setUserType] = useState<
    "employee" | "corporate" | "admin" | "owner"
  >("employee")
  const loading = useSelector((state: RootState) => state.authReducer.loading)
  const schema = yup
    .object({
      phoneNumber: yup
        .string()
        .matches(flexiblePhoneRegEx, "Phone number is not valid")
        .required("Phone Number  is required"),
      password: yup
        .string()
        .min(8, "Password length must be greater than 8")
        .max(25, "Password length must be 25 and less")
        .required("password"),
    })
    .required()

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isValid },
    reset,
    setValue,
  } = useForm<Account>({
    resolver: yupResolver(schema),
    mode: "onBlur",
  })

  function onSubmit(data: Account) {
    const loginData = {
      ...data,
      type: userType,
      phoneNumber: parsePhoneNumber(data.phoneNumber)
    }
    login(loginData)
  }

  const onError = (error: any) => {}

  return (
    <div className="flex justify-center items-center w-full min-h-screen">
      <section className="flex flex-col justify-center items-center pt-6">
        <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
              {t("projectTitle")}
            </h1>
            <form
              className="space-y-4 md:space-y-6"
              onSubmit={handleSubmit(onSubmit, onError)}
            >
              <div>
                <TextInput
                  {...register(`phoneNumber`)}
                  label={t("phoneNumber")}
                  placeholder={t("enterPhoneNumber")}
                  type="tel"
                  autoComplete="tel"
                  id="phoneNumber" // Important for autofill mapping
                  classNames={{
                    input:
                      " bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                  }}
                  className="w-full"
                  error={errors.phoneNumber?.message}
                />
              </div>
              <div>
                <PasswordInput
                  classNames={{
                    input:
                      " bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                  }}
                  label={t("password")}
                  placeholder={t("password")}
                  // Add these HTML attributes:
                  autoComplete="current-password"
                  id="password" // Important for autofill mapping
                  {...register("password")}
                  className="w-full"
                  error={errors.password?.message}
                />
              </div>
              <div>
                <Select
                  classNames={{
                    label: "dark:text-white",
                    input:
                      " bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                  }}
                  className="w-full"
                  label={t("loginAs")}
                  placeholder={t("loginAs")}
                  value={userType}
                  onChange={(e: any) => setUserType(e)}
                  data={[
                    { label: t("admin"), value: "employee" },
                    { label: t("owner", { count: 1 }), value: "owner" },
                    { label: t("tenant", { count: 1 }), value: "tenant" },
                  ]}
                />
              </div>
              <Button
                type="submit"
                loading={loading}
                className="w-full text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                {t("login")}
              </Button>

              <Text className="text-sm font-light text-gray-500 dark:text-gray-400">
                {t("forgetYourPassword")}?{" "}
                <Link
                  className="font-medium text-blue-600 hover:underline dark:text-blue-500"
                  to="/forget-password"
                >
                  {t("resetHere")}
                </Link>
              </Text>
            </form>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Login
